import { Box, Flex, Text, VStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { VictoryAxis, VictoryChart, VictoryLine, VictoryTheme } from 'victory';

import { CreateAnnualReport } from '../../models';
import { currencyFormatter } from '../../utils';
import { chartColors, Legend } from '../Graph';

interface ChartData {
  x: number;
  y: number;
}

type CashOverLifeReportProp = CreateAnnualReport;

export function OverLifeChart({
  annualRevenues,
  annualExpenses,
  annualCashFlow
}: CashOverLifeReportProp) {
  const [revenuesData, setRevenuesData] = useState<ChartData[]>([]);
  const [expensesData, setExpenseData] = useState<ChartData[]>([]);
  const [cashFlowData, setCashFlowData] = useState<ChartData[]>([]);

  useEffect(() => {
    setRevenuesData(annualRevenues.map((value, i) => ({ x: i + 1, y: value })));
    setExpenseData(annualExpenses.map((value, i) => ({ x: i + 1, y: value })));
    setCashFlowData(annualCashFlow.map((value, i) => ({ x: i + 1, y: value })));
  }, [annualRevenues, annualExpenses, annualCashFlow]);

  return (
    <Flex justify="center" align="center" fontFamily="Montserrat" color="#5A5A5A" mb="20">
      <Box h="xl" w="full">
        <VStack align="center">
          <Text fontSize="2xl" fontWeight="bold">
            Cash Flow Over Life of Loan
          </Text>
          <Legend labels={['Expenses', 'Income', 'Cash Flow']} />
        </VStack>
        <VictoryChart domainPadding={{ x: 5, y: 10 }} width={650} theme={VictoryTheme.material}>
          <VictoryAxis
            label={'Year'}
            style={{
              tickLabels: {
                fill: '#5A5A5A',
                fontFamily: 'Montserrat'
              },
              axisLabel: { padding: 30, fontFamily: 'Montserrat' }
            }}
          />
          <VictoryAxis
            dependentAxis
            label={'Amount'}
            tickFormat={(t) => `${currencyFormatter(t)}`}
            style={{
              tickLabels: {
                fill: '#5A5A5A',
                fontFamily: 'Montserrat'
              },
              axisLabel: { padding: 110, fontFamily: 'Montserrat' }
            }}
          />
          <VictoryLine
            data={expensesData}
            interpolation="natural"
            style={{
              data: { stroke: `${chartColors[0]}` },
              parent: { fontFamily: 'Montserrat', fill: '#5A5A5A' }
            }}
          />
          <VictoryLine
            data={revenuesData}
            interpolation="natural"
            style={{
              data: { stroke: `${chartColors[1]}` },
              parent: { fontFamily: 'Montserrat', fill: '#5A5A5A' }
            }}
          />
          <VictoryLine
            data={cashFlowData}
            interpolation="natural"
            style={{
              data: { stroke: `${chartColors[2]}` },
              parent: { fontFamily: 'Montserrat', fill: '#5A5A5A' }
            }}
          />
        </VictoryChart>
      </Box>
    </Flex>
  );
}

export default OverLifeChart;
